import React, { useEffect, useState } from 'react';
import { message, Button, Checkbox, Form, Input, Row, Col } from "antd";
import { Link } from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import { useAuth } from "authentication";
import AppNotificationContainer from "components/AppNotificationContainer";
import AntDraggableModal from 'components/AntDraggableModal';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import Cookies from 'js-cookie';

const SignIn = () => {
  const { isLoading, error, setError, userLogin, loginSecurityCodeData, showLoginSecurityCode, setShowLoginSecurityCode, checkLoginSecurityCode } = useAuth();
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [loginForm] = Form.useForm();
  const [resetPasswordForm] = Form.useForm();
  const [loginSecurityCodeForm] = Form.useForm();
  const [seconds, setSeconds] = useState(60);
  const [isDisabled, setIsDisabled] = useState(false);

  document.title = 'Login';

  const handleSendCodeClick = () => {
    setIsDisabled(true);
    setSeconds(60);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSeconds(seconds - 1);
      if (seconds === 0) {
        clearInterval(intervalId);
        setIsDisabled(false);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [seconds]);

  const onFinishFailed = errorInfo => {
  };

  const onFinish = values => {
    Cookies.set('HF_Client_Username', values.Username, { expires: 3650 });
    Cookies.set('HF_Client_Company', values.Company, { expires: 3650 });
    userLogin(values);
  };

  const onResetPasswordFinish = values => {
    setConfirmLoading(true);
    httpClient
      .post('System/Login/ResetPassword', values)
      .then(({ data }) => {
        if (data.result) {
          message.info(data.message);
          setShowResetPassword(false);
          setConfirmLoading(false);
        } else {
          message.warning(data.message);
          setConfirmLoading(false);
        }
      })
      .catch(function (error) {
        message.error(error.stack);
        setConfirmLoading(false);
      });
  };

  const onLoginSecurityCodeFinish = values => {
    values.Remember = loginSecurityCodeData.Remember;
    values.ClientUserId = loginSecurityCodeData.data;
    checkLoginSecurityCode(values);
  }

  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-background">
            </div>
            <div className="gx-app-logo">
              <img alt="example" src="/assets/images/login-logo.png" />
            </div>
          </div>
          <div className="gx-app-login-content">
            <h3 style={{ textAlign: 'center', marginBottom: '10px' }}>Client Login</h3>
            <Form
              action="/"
              form={loginForm}
              initialValues={{ remember: true }}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0">
              <Form.Item
                initialValue={Cookies.get('HF_Client_Username')}
                rules={[{ required: true, message: 'Please input your Username!' }]} name="Username">
                <Input placeholder="Username" />
              </Form.Item>
              <Form.Item
                initialValue=""
                rules={[{ required: true, message: 'Please input your Password!' }]} name="Password">
                <Input.Password placeholder="Password" />
              </Form.Item>
              <Form.Item
                initialValue={Cookies.get('HF_Client_Company')}
                rules={[{ required: true, message: 'Please input your Company!' }]} name="Company">
                <Input placeholder="Company" />
              </Form.Item>
              <Row>
                <Col span={12} style={{ paddingLeft: '0px', marginTop: '-6px' }}>
                  <Form.Item name="Remember" valuePropName="checked">
                    <Checkbox><IntlMessages id="app.userAuth.rememberMe" /></Checkbox>
                  </Form.Item>
                </Col>
                <Col span={12} style={{ paddingRight: '0px' }}>
                  <Button style={{ float: 'right' }} type="primary" className="gx-mb-0" htmlType="submit" onClick={() => { handleSendCodeClick(); }}>
                    <IntlMessages id="app.userAuth.signIn" />
                  </Button>
                </Col>
              </Row>
              <Form.Item>
                <span
                  style={{ float: 'right', textDecoration: 'underline', color: '#038fde', cursor: 'pointer' }}
                  onClick={() => setShowResetPassword(true)}><IntlMessages id="app.userAuth.forgotPassword" /></span>
              </Form.Item>
            </Form>
          </div>
          <AppNotificationContainer loading={isLoading} error={error} setError={setError} />
        </div>
      </div>

      <AntDraggableModal
        title={<IntlMessages id="app.userAuth.resetPassword" />}
        open={showResetPassword}
        onOk={() => { resetPasswordForm.submit(); }}
        onCancel={() => { setShowResetPassword(false); resetPasswordForm.resetFields(); }}
        confirmLoading={confirmLoading}
        width={600}
        okText="Submit"
        maskClosable={false}
      >
        <IntlMessages id="app.userAuth.resetPasswordTips" />
        <Form
          form={resetPasswordForm}
          style={{ marginTop: '8px' }}
          name="resetPasswordForm"
          onFinish={onResetPasswordFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0">
          <Form.Item
            initialValue=""
            rules={[{ required: true, message: 'Please input your Username!' }]} name="Username">
            <Input placeholder="Username" />
          </Form.Item>
          <Form.Item
            initialValue=""
            rules={[{ required: true, message: 'Please input your Company!' }]} name="Company">
            <Input placeholder="Company" />
          </Form.Item>
        </Form>
      </AntDraggableModal>

      <AntDraggableModal
        title="Security Code"
        open={showLoginSecurityCode}
        onCancel={() => {
          setShowLoginSecurityCode(false);
          loginSecurityCodeForm.resetFields();
        }}
        width={600}
        maskClosable={false}
        footer={[
          <Button key="back" onClick={() => {
            setShowLoginSecurityCode(false);
            loginSecurityCodeForm.resetFields();
          }}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => {
            loginSecurityCodeForm.submit();
          }}>
            Submit
          </Button>,
          <Button key="Resend" disabled={isDisabled} style={{ backgroundColor: '#ff9800', color: '#ffffff' }} onClick={() => {
            handleSendCodeClick();
            loginForm.submit();
          }}>
            {isDisabled ? 'Resend after ' + seconds + ' seconds' : 'Resend'}
          </Button>,
        ]}
      >
        <div dangerouslySetInnerHTML={{ __html: loginSecurityCodeData.message }}></div>
        <Form
          form={loginSecurityCodeForm}
          style={{ marginTop: '8px' }}
          name="loginSecurityCodeForm"
          onFinish={onLoginSecurityCodeFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0">
          <Form.Item
            rules={[{ required: true, message: 'Please input security code' }]} name="Code">
            <Input placeholder="Security Code" />
          </Form.Item>
        </Form>
      </AntDraggableModal>
    </div>
  );
};

export default SignIn;
